import styled from "styled-components";
import { BodyRegular } from "./fonts/Body";


export const TableContents = styled(BodyRegular)<any>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
